<script>
export default {
    mounted() {
        return this.$store.dispatch("flow/gotoNextStep");
    },
    render: () => null
};
</script>
